import { useState, useContext, useEffect } from "react";
import { FaPlus, FaCheck } from "react-icons/fa";
import { SongsContext } from "../context/SongsContext";

function BrowseSongsSong({ song, newSongs, setNewSongs }) {
    const [state, dispatch] = useContext(SongsContext);
    const [isSelected, setIsSelected] = useState(newSongs.includes(song));

    useEffect(() => {
        setIsSelected(newSongs.includes(song));
    }, [newSongs]);

    const removeSong = (title) => {
        setNewSongs(newSongs.filter((song) => song.title !== title));
    };
    const addSong = (song) => {
        setNewSongs([...newSongs, song]);
    };
    return (
        <div
            style={{
                width: "90%",
                marginBottom: "1vh",
                borderRadius: "0.5vh",
                border: isSelected ? "2px solid #4db193" : "1px solid #2a3854",
                padding: "1vh",
                backgroundColor: isSelected ? "#1a2d3a" : "#2a3854",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: "row",
                cursor: "pointer",
                transition: "all 0.2s ease",
                hover: {
                    borderColor: "#4db193",
                },
            }}
            onClick={() => {
                isSelected
                    ? //Remove from array
                      removeSong(song.title)
                    : //Add to array
                      addSong(song);
                setIsSelected(!isSelected);
            }}
            onMouseEnter={(e) => {
                if (!isSelected) {
                    e.currentTarget.style.borderColor = "#4db193";
                    e.currentTarget.style.backgroundColor = "#1a2d3a";
                }
            }}
            onMouseLeave={(e) => {
                if (!isSelected) {
                    e.currentTarget.style.borderColor = "#2a3854";
                    e.currentTarget.style.backgroundColor = "#2a3854";
                }
            }}
        >
            <div style={{ flex: 1, minWidth: 0 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        marginBottom: "0.8vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: 14,
                            fontWeight: 500,
                            marginBottom: "0.2vh",
                            color: "white",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: "100%",
                            textAlign: "left",
                        }}
                    >
                        {song.title}
                    </div>
                    <div
                        style={{
                            fontSize: 12,
                            color: "#9ca3af",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: "100%",
                            textAlign: "left",
                        }}
                    >
                        {song.artist}
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.3vh",
                        alignItems: "flex-start",
                    }}
                >
                    {song.text.split(/\s+/).map((word, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: "#161f33",
                                border: "1px solid #2a3854",
                                borderRadius: "0.3vh",
                                padding: "0.3vh 0.6vh",
                                fontSize: 11,
                                color: "#b8c5d1",
                                display: "inline-block",
                            }}
                        >
                            {word}
                        </div>
                    ))}
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "1vh",
                    flexShrink: 0,
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: isSelected ? "#4db193" : "transparent",
                    transition: "all 0.2s ease",
                }}
            >
                {isSelected ? (
                    <FaCheck color="white" size={12} />
                ) : (
                    <FaPlus color="#6b7a8f" size={12} />
                )}
            </div>
        </div>
    );
}

export default BrowseSongsSong;
